module.exports = __webpack_public_path__ + "f9ba9360ba783004e5482d9510443780.png";